import { render, staticRenderFns } from "./otherproject.vue?vue&type=template&id=435cd8ed&"
import script from "./otherproject.vue?vue&type=script&lang=js&"
export * from "./otherproject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports